import axios from "axios";
import moment from "moment";
import { useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export const UpgradeSubscriptionModal = ({
  nextPaymentDate,
  setSubscriptionData,
  currentPlan,
}) => {
  const planModalRef = useRef();
  const confirmationModalRef = useRef();
  const userId = useSelector((state) => state.user.userId);
  const scheduleSettings = useSelector(
    (state) => state.user?.scheduleMeetingSettings
  );

  const [price, setPrice] = useState();
  const [selectedPlan, setSelectedPlan] = useState();
  const [dailyCredit, setDailyCredit] = useState();
  const [maxCreditLimit, setMaxCreditLimit] = useState();

  const [subscriptionConfirmation, setSubscriptionConfirmation] =
    useState(false);

  const handleSubmitPlan = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        "https://3for3networking.com/backend/wp-content/plugins/wl-api/stripe-payment/create.php",
        {
          userId: userId,
          type: "subscription",
          credit: 0,
          plan: selectedPlan,
          price: price,
          max_credit_limit: maxCreditLimit,
          daily_credit: dailyCredit,
        }
      );

      if (response.data.status === "active") {
        confirmationModalRef.current.click();
        toast.success("Subscription Paid Successfully!");
        setSubscriptionData(response.data);
      }

      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTriggerConfirmation = (event, selectedPlan, price, dailycredit, maxcreditlimit) => {
    event.preventDefault();
    planModalRef.current.click();
    setSubscriptionConfirmation(true);
    setSelectedPlan(selectedPlan);
    setPrice(price);
    setDailyCredit(dailycredit);
    setMaxCreditLimit(maxcreditlimit);
  };

  const handleCloseConfirmation = (event) => {
    event.preventDefault();
    setSubscriptionConfirmation(false);
    setSelectedPlan("");
    setPrice("");
    setDailyCredit("");
    setMaxCreditLimit("");
  };

  return (
    <>
      <div
        className="modal fade"
        id="upgradeSubscription"
        data-backdrop="static"
        data-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="bg-dark modal-content px-3">
            <div className="bg-dark border-0 modal-header pb-0 px-2">
              <h4 className="modal-title text-white" id="staticBackdropLabel">
                Choose a plan that is right for you!
              </h4>
              <button
                ref={planModalRef}
                type="button"
                className="btn btn-link p-0 text-white"
                data-dismiss="modal"
                aria-label="Close"
              >
                {/* <span aria-hidden="true">&times;</span> */}
                <IoMdClose fontSize="25px" />
              </button>
            </div>
            <div className="modal-body bg-dark">
              <div className="row">
                <div className="col p-2">
                  <div className="card h-100">
                    <div className="card-body d-flex flex-column justify-content-between p-3">
                      <div className="pb-4">
                        <h5 className="card-title mb-1">Forever Free</h5>
                        <p className="card-subtitle text-muted f-14">
                          Perfect for beginners
                        </p>
                        <small className="h2 text-blue mt-2 d-block">
                          $0/mo
                        </small>
                        <ul className="mt-3 p-0 pl-3 f-14">
                          <li>10 daily credits</li>
                          <li>100 max credits</li>
                        </ul>
                      </div>
                      <div className="text-center">
                        {!currentPlan ? (
                          <ActivePlanBtn />
                        ) : (
                          <button
                            className="btn btn-primary f-14 w-75 rounded-10"
                            data-toggle="modal"
                            data-target="#subscriptionConfirmation"
                            onClick={(e) =>
                              handleTriggerConfirmation(
                                e,
                                "forever-free",
                                0,
                                10,
                                100
                              )
                            }
                          >
                            Select
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col p-2">
                  <div className="card h-100">
                    <div className="card-body d-flex flex-column justify-content-between p-3">
                      <div className="pb-4">
                        <h5 className="card-title mb-1">Premium</h5>
                        <p className="card-subtitle text-muted f-14">
                          Ideal for Professionals
                        </p>
                        <small className="h2 text-blue mt-2 d-block">
                          $50/mo
                        </small>
                        <ul className="mt-3 p-0 pl-3 f-14">
                          <li>400 monthly credits</li>
                          <li>400 max credits</li>
                          <li>Access to groups</li>
                        </ul>
                      </div>
                      <div className="text-center">
                        {currentPlan === "premium" ? (
                          <ActivePlanBtn />
                        ) : (
                          <button
                            className="btn btn-primary f-14 w-75 rounded-10"
                            data-toggle="modal"
                            data-target="#subscriptionConfirmation"
                            onClick={(e) =>
                              handleTriggerConfirmation(
                                e,
                                "premium",
                                50,
                                30,
                                400
                              )
                            }
                          >
                            Select
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col p-2">
                  <div className="card h-100">
                    <div className="card-body d-flex flex-column justify-content-between p-3">
                      <div className="pb-4">
                        <h5 className="card-title mb-1">Premium +</h5>
                        <p className="card-subtitle text-muted f-14">
                          Best for Power Connectors
                        </p>
                        <small className="h2 text-blue mt-2 d-block">
                          $100/mo
                        </small>
                        <ul className="mt-3 p-0 pl-3 f-14">
                          <li>400 monthly credits</li>
                          <li>400 max credits</li>
                          <li>Access to groups</li>
                          <li>Create public groups</li>
                          <li>Create private groups</li>
                        </ul>
                      </div>

                      <div className="text-center">
                        {currentPlan === "premium_plus" ? (
                          <ActivePlanBtn />
                        ) : (
                          <button
                            className="btn btn-primary f-14 w-75 rounded-10"
                            data-toggle="modal"
                            data-target="#subscriptionConfirmation"
                            onClick={(e) =>
                              handleTriggerConfirmation(
                                e,
                                "premium_plus",
                                100,
                                30,
                                400
                              )
                            }
                          >
                            Select
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="col p-2">
                  <div className="card h-100">
                    <div className="card-body d-flex flex-column justify-content-between p-3">
                      <div className="pb-4">
                        <h5 className="card-title mb-1">Elite Pro</h5>
                        <p className="card-subtitle text-muted f-14">
                          Best for Power Users
                        </p>
                        <small className="text-primary">$50/monthly</small>
                        <ul className="mt-5 p-0 pl-3 f-14">
                          <li>50 daily credits</li>
                          <li>10000 max credits</li>
                        </ul>
                      </div>

                      <div className="text-center">
                        {currentPlan === "elite-pro" ? (
                          <ActivePlanBtn />
                        ) : (
                          <button
                            className="btn btn-primary f-14 w-75 rounded-10"
                            data-toggle="modal"
                            data-target="#subscriptionConfirmation"
                            onClick={(e) =>
                              handleTriggerConfirmation(
                                e,
                                "elite-pro",
                                50,
                                50,
                                10000
                              )
                            }
                          >
                            Select
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <div className="col p-2">
                  <div className="card h-100">
                    <div className="card-body">
                      <h5 className="card-title mb-1">Enterprise</h5>
                      <p className="card-subtitle text-muted f-14">
                        Custom Solutions
                      </p>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Subcription Confirmation */}
      {subscriptionConfirmation ? (
        <div
          className="modal fade"
          id="subscriptionConfirmation"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Subscription Confirmation
                </h5>
                <button
                  ref={confirmationModalRef}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Confirm to start your subscription with recurring billing.
                </p>
                <p>
                  <b>Plan Type:</b>{" "}
                  <span className="text-capitalize">
                    {selectedPlan?.replace("-", " ")}
                  </span>
                </p>
                <p>
                  <b>Amount:</b> {price ? `$${price.toFixed(2)}` : "$0.00"}
                </p>
                <p>
                  <b>Next Payment:</b>{" "}
                  {nextPaymentDate
                    ? moment(nextPaymentDate)
                        .tz(scheduleSettings?.timeZone?.value)
                        .format("MMMM Do, YYYY")
                    : moment().add(30, "days").format("MMMM Do, YYYY")}
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary rounded-10"
                  data-dismiss="modal"
                  data-toggle="modal"
                  data-target="#upgradeSubscription"
                  onClick={handleCloseConfirmation}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary rounded-10"
                  onClick={handleSubmitPlan}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export const UpgradePlanBtn = ({ handleClick }) => {
  return (
    <button
      className="btn btn-primary f-14 w-75 rounded-10"
      data-toggle="modal"
      data-target="#subscriptionConfirmation"
      onClick={handleClick}
    >
      Upgrade
    </button>
  );
}

export const ActivePlanBtn = () => {
  return (
    <button
      className="btn btn-secondary disabled f-14 w-75 rounded-10"
      style={{ cursor: "not-allowed" }}
    >
      Current Plan
    </button>
  );
}